// src/components/Projects.jsx
/**
 * Список проектов (карточки в .pj-grid).
 * Маппинг данных и передача variant="list" в общий ProjectCard.
 * Раскладка сетки (layout): 'tiles' (по умолчанию) или 'rows'.
 *
 * Пересчёт fact убран (D-13): ProjectCard берёт его из project.actualHours.
 * В projectStatsById остались только assigneeIds.
 */
import { useMemo } from "react";
import { ProjectCard } from "./cards/ProjectCard";

export default function Projects({
  db,
  ur,
  openProject,
  projects,
  layout = "tiles",
  openTag,
  onMoveProject,
  openCopyProject,
  openTemplateFromProject,
  openProjectAccess,
}) {
  const employeesById = useMemo(
    () => new Map(db.employees.map((e) => [e.id, e])),
    [db.employees],
  );

  const projectStatsById = useMemo(() => {
    const map = new Map();
    const byProject = new Map();

    for (const t of db.tasks) {
      if (!t.isActive) continue; // Используем серверный флаг isActive (D-15)
      let list = byProject.get(t.projectId);
      if (!list) {
        list = [];
        byProject.set(t.projectId, list);
      }
      list.push(t);
    }

    byProject.forEach((list, projectId) => {
      const assigneeIds = [];
      const seen = new Set();

      for (const t of list) {
        if (t.assigneeId && !seen.has(t.assigneeId)) {
          seen.add(t.assigneeId);
          assigneeIds.push(t.assigneeId);
        }
      }

      map.set(projectId, { assigneeIds });
    });

    return map;
  }, [db.tasks]);

  const gridClassName = layout === "rows" ? "pj-grid pj-grid--rows" : "pj-grid";

  return (
    <div>
      <div className={gridClassName}>
        {projects.map((p) => {
          const stats = projectStatsById.get(p.id) || { assigneeIds: [] };
          return (
            <ProjectCard
              key={p.id}
              project={p}
              assigneeIds={stats.assigneeIds}
              employeesById={employeesById}
              db={db}
              user={ur}
              variant="list"
              openProject={openProject}
              openTag={openTag}
              onMove={onMoveProject}
              onCopy={openCopyProject}
              onMakeTemplate={openTemplateFromProject}
              onOpenAccess={openProjectAccess}
            />
          );
        })}
      </div>
    </div>
  );
}
